import { render, staticRenderFns } from "./EventLogTableButton.vue?vue&type=template&id=36d2713b&"
import script from "./EventLogTableButton.vue?vue&type=script&lang=js&"
export * from "./EventLogTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports